import React, { useState } from 'react';
import { TransHtml, useLocale } from '../i18n/LocaleContext';
import { analytics, WebAnalyticsEvent } from '../analytics/analyticsService';

const ITEMS = [
  { q: 'faq.1.q', a: 'faq.1.a' },
  { q: 'faq.2.q', a: 'faq.2.a' },
  { q: 'faq.3.q', a: 'faq.3.a' },
  { q: 'faq.4.q', a: 'faq.4.a' },
  { q: 'faq.5.q', a: 'faq.5.a' },
  { q: 'faq.6.q', a: 'faq.6.a' },
  { q: 'faq.7.q', a: 'faq.7.a' },
];

export const Faq = (): React.JSX.Element => {
  const { t } = useLocale();
  const [open, setOpen] = useState<number>(0);

  const toggle = (i: number, q: string): void => {
    setOpen((cur) => {
      const next = cur === i ? -1 : i;
      if (next === i) {
        analytics.logEvent(WebAnalyticsEvent.FAQ_OPEN, { question: q });
      }
      return next;
    });
  };

  return (
    <section id="faq">
      <div className="wrap faq-grid">
        <div>
          <span className="eyebrow">{t('faq.eyebrow')}</span>
          <TransHtml tag="h2" tKey="faq.h" style={{ marginTop: 12 }} />
          <TransHtml tag="p" tKey="faq.sub" style={{ marginTop: 20, maxWidth: 380 }} />
        </div>
        <div className="faq-list">
          {ITEMS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className={`faq-item${isOpen ? ' open' : ''}`}>
                <button
                  type="button"
                  className="faq-summary"
                  aria-expanded={isOpen}
                  onClick={() => toggle(i, item.q)}
                >
                  <span>{t(item.q)}</span>
                  <span className="chev" aria-hidden />
                </button>
                <div className="faq-answer">
                  <div className="faq-answer-inner">
                    <TransHtml tag="p" tKey={item.a} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
